import { useTranslation } from 'react-i18next';
import { useApp } from '@/context/AppContext';

export default function LogChemModal({ data }) {
  const { t } = useTranslation(['painterops', 'common']);
  const { logChem, custById, closeModal } = useApp();
  const cust = custById(data?.custId);

  const handleSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const d = Object.fromEntries(fd);
    logChem(data?.stopId, {
      cl:  parseFloat(d.cl),
      ph:  parseFloat(d.ph),
      alk: parseInt(d.alk),
      cya: parseInt(d.cya),
    }, d.notes || '');
    closeModal();
  };

  return (
    <div className="modal">
      <div className="modal-head">
        <span className="modal-title">{t('chemLog.title')}</span>
        <button className="btn btn-ghost btn-sm" onClick={closeModal}>✕</button>
      </div>
      <div className="modal-body">
        <form onSubmit={handleSubmit}>
          {cust && (
            <div style={{
              marginBottom: 14,
              padding: '10px 12px',
              background: 'var(--s2)',
              borderRadius: 8,
              fontSize: 13,
              color: 'var(--t2)',
            }}>
              {t('chemLog.loggingFor')} <strong style={{ color: 'var(--t1)' }}>{cust.name}</strong> · {cust.addr}
            </div>
          )}
          <div className="form-row">
            <div className="field">
              <label>{t('chemLog.freeChlorineLong')}</label>
              <input name="cl" type="number" step="0.1" min="0" max="10" placeholder="2.4" required />
            </div>
            <div className="field">
              <label>{t('chemLog.phLong')}</label>
              <input name="ph" type="number" step="0.1" min="6" max="10" placeholder="7.4" required />
            </div>
          </div>
          <div className="form-row">
            <div className="field">
              <label>{t('chemLog.alkalinityLong')}</label>
              <input name="alk" type="number" step="1" min="0" max="300" placeholder="95" required />
            </div>
            <div className="field">
              <label>{t('chemLog.cyaLong')}</label>
              <input name="cya" type="number" step="1" min="0" max="200" placeholder="40" required />
            </div>
          </div>
          <div className="field">
            <label>{t('chemLog.notesSection')}</label>
            <textarea name="notes" placeholder={t('chemLog.notesPlaceholderLong')} />
          </div>
          <div className="modal-foot">
            <button type="button" className="btn btn-ghost" onClick={closeModal}>{t('common:actions.cancel')}</button>
            <button type="submit" className="btn btn-primary">{t('chemLog.submitModal')}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
